import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"header"},[_c(VRow,{attrs:{"no-gutters":"","justify-center":"","align-center":""}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/kasasaLogoNew.svg"),"alt":"Kasasa Logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }